import { MeshStyles, Style } from 'santa-mesh/cjs/src/Types'
import _ from 'lodash'
import { MESH_ID_SEPARATOR, skinPartId } from './meshConstants'

const isContainerId = (meshId: string, meshContainerId: string) => {
	const containerIdRegex = new RegExp(`^(${meshContainerId})(inlineContent|inlineContent-gridContainer)$`)
	return containerIdRegex.test(meshId)
}
const isWedgeId = (meshId: string) => meshId.includes('wedge')
const isRotatedChildId = (rotatedComponents: Array<string>, meshId: string) => _.includes(rotatedComponents, meshId)
const isRotatedWrapperId = (meshId: string) => meshId.includes('rotated-wrapper')
const getWrappedCompId = (rotatedWrapperId: string) => rotatedWrapperId.replace('-rotated-wrapper', '')
const hasClass = (meshId: string) => meshId.includes(MESH_ID_SEPARATOR)

const idsToSelectors = (
	meshContainerId: string,
	stylesMap: MeshStyles,
	rotatedComponents: Array<string>,
	isChildOfRepeater: boolean
) =>
	_.mapKeys(stylesMap, (style: Style, meshId: string) => {
		const shouldAddClass = hasClass(meshId)
		const splitMeshId = _.split(meshId, MESH_ID_SEPARATOR)
		meshId = splitMeshId[0]
		const className = shouldAddClass ? `.${splitMeshId[1]}` : ''
		const meshContainerDisplayedOnlyIdPrefix = `${meshContainerId}__`
		const classSelector = shouldAddClass ? `[id="${meshContainerId}"]${className} ` : ''
		const repeaterClassSelector = shouldAddClass ? `[id^="${meshContainerDisplayedOnlyIdPrefix}"]${className} ` : ''

		if (isContainerId(meshId, meshContainerId) || isWedgeId(meshId)) {
			// meshId=container1inlineContent or container1inlineContent-gridContainer or container1inlineContent-wedge-1
			const suffix = _.replace(meshId, meshContainerId, '') // suffix=inlineContent or inlineContent-gridContainer or inlineContent-wedge-1

			const regularSelector = `${classSelector}[data-mesh-id=${meshId}]`
			const repeaterSelector = `${repeaterClassSelector}[data-mesh-id^="${meshContainerDisplayedOnlyIdPrefix}"][data-mesh-id$="${suffix}"]`

			return isChildOfRepeater ? repeaterSelector : regularSelector
		}

		if (isRotatedChildId(rotatedComponents, meshId)) {
			// We need specific rule for rotated child because of repeater selector
			// meshId = child1
			const regularSelector = `${classSelector}[data-mesh-id="${meshId}-rotated-wrapper"] > [id="${meshId}"]`
			const repeaterSelector = `${repeaterClassSelector}[data-mesh-id^="${meshId}"][data-mesh-id$="-rotated-wrapper"] > [id^="${meshId}"]`

			return isChildOfRepeater ? repeaterSelector : regularSelector
		}

		if (isRotatedWrapperId(meshId)) {
			// meshId = child1-rotated-wrapper
			const regularSelector = `${classSelector}[data-mesh-id=${meshId}]`
			const repeaterSelector = `${repeaterClassSelector}[data-mesh-id^="${getWrappedCompId(
				meshId
			)}"][data-mesh-id$="rotated-wrapper"]`

			return isChildOfRepeater ? repeaterSelector : regularSelector
		}

		// meshId = child1
		// We need to add grid-container selector here because sometimes we calculate mesh but we don't render meshContainer
		const regularSelector = `${classSelector}[data-mesh-id=${meshContainerId}${skinPartId}-gridContainer] > [id="${meshId}"]`
		const repeaterSelector = `${repeaterClassSelector}[data-mesh-id^=${meshContainerDisplayedOnlyIdPrefix}] > [id^="${meshId}"]`

		return isChildOfRepeater ? repeaterSelector : regularSelector
	})

export const getMeshStyles = (
	id: string,
	stylesMap: MeshStyles,
	rotatedComponents: Array<string>,
	isChildOfRepeater: boolean
): MeshStyles => {
	// structure2mesh returns css properties in camelCase (for React). We have to transform them to kebab-case
	stylesMap = _.mapValues(stylesMap, (style) => _.mapKeys(style, (__, key) => _.kebabCase(key)))
	return idsToSelectors(id, stylesMap, rotatedComponents, isChildOfRepeater)
}
